module.exports = __webpack_public_path__ + "img/gr.6ac69b06.svg";